import { Users, Trash2, MessageCircle, DollarSign } from 'lucide-react';

export const STATUS_CONFIG = {
  nuevo:     { label: 'Nuevo',     color: 'bg-blue-500/20 text-blue-400 border-blue-500/30',           bgColumn: 'bg-blue-950/30',    dot: 'bg-blue-400',    icon: Users },
  spam:      { label: 'Spam',      color: 'bg-red-500/20 text-red-400 border-red-500/30',              bgColumn: 'bg-red-950/30',     dot: 'bg-red-400',     icon: Trash2 },
  consultas: { label: 'Consultas', color: 'bg-amber-500/20 text-amber-400 border-amber-500/30',        bgColumn: 'bg-amber-950/30',   dot: 'bg-amber-400',   icon: MessageCircle },
  valido:    { label: 'Válido',    color: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',  bgColumn: 'bg-emerald-950/30', dot: 'bg-emerald-400', icon: DollarSign },
};

// Color propio para cada etiqueta de estado (filtros y menus): los cajeros
// los confundian al tener todos el mismo fondo.
export const STATUS_CHIP_COLORS = {
  all: {
    on:  'border-zinc-500 bg-zinc-700 text-white',
    off: 'border-zinc-800 bg-zinc-900/60 text-zinc-400 hover:bg-zinc-800/70 hover:text-zinc-200',
  },
  nuevo: {
    on:  'border-blue-400/70 bg-blue-500/30 text-blue-50',
    off: 'border-blue-500/25 bg-blue-500/10 text-blue-300/90 hover:bg-blue-500/20 hover:text-blue-200',
    row: 'border-l-blue-500/70 bg-blue-500/10 hover:bg-blue-500/25',
    badge: 'border-blue-400/60 bg-blue-500/25 text-blue-50',
  },
  spam: {
    on:  'border-red-400/70 bg-red-500/30 text-red-50',
    off: 'border-red-500/25 bg-red-500/10 text-red-300/90 hover:bg-red-500/20 hover:text-red-200',
    row: 'border-l-red-500/70 bg-red-500/10 hover:bg-red-500/25',
    badge: 'border-red-400/60 bg-red-500/25 text-red-50',
  },
  consultas: {
    on:  'border-amber-400/70 bg-amber-500/30 text-amber-50',
    off: 'border-amber-500/25 bg-amber-500/10 text-amber-300/90 hover:bg-amber-500/20 hover:text-amber-200',
    row: 'border-l-amber-500/70 bg-amber-500/10 hover:bg-amber-500/25',
    badge: 'border-amber-400/60 bg-amber-500/25 text-amber-50',
  },
  valido: {
    on:  'border-emerald-400/70 bg-emerald-500/30 text-emerald-50',
    off: 'border-emerald-500/25 bg-emerald-500/10 text-emerald-300/90 hover:bg-emerald-500/20 hover:text-emerald-200',
    row: 'border-l-emerald-500/70 bg-emerald-500/10 hover:bg-emerald-500/25',
    badge: 'border-emerald-400/60 bg-emerald-500/25 text-emerald-50',
  },
};

export const LINE_TYPE_CONFIG = {
  publi:     { label: 'Publicidad', color: 'bg-blue-500/20 text-blue-400' },
  principal: { label: 'Principal',  color: 'bg-emerald-500/20 text-emerald-400' },
  spam:      { label: 'Spam',       color: 'bg-red-500/20 text-red-400' },
};

export const STATUS_ORDER = ['nuevo', 'spam', 'consultas', 'valido'];

export const BADGE_COLORS = {
  blue:    { bg: 'bg-blue-500/15',    border: 'border-blue-500/40',    text: 'text-blue-300',    icon: 'text-blue-400',    dot: 'bg-blue-400' },
  emerald: { bg: 'bg-emerald-500/15', border: 'border-emerald-500/40', text: 'text-emerald-300', icon: 'text-emerald-400', dot: 'bg-emerald-400' },
  amber:   { bg: 'bg-amber-500/15',   border: 'border-amber-500/40',   text: 'text-amber-300',   icon: 'text-amber-400',   dot: 'bg-amber-400' },
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
